import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { primarycolor, semiprimarycolor } from '../../utils/colors';
import { logoutuser, getsessionuser } from '../../utils/sessions';
import Loadingspinner from '../../components/Loadingspinner';
import { ForumOutlined, Group, HandshakeOutlined, Person, Speed } from '@mui/icons-material';
import axios from 'axios';
import { Fetchmessagecounterurl } from '../../utils/chaturls';
import AccountMenu from './accountmenu';
import Dashboard from './pages/dashboard';
import Popupdialog from '../../components/popupdialog';
import Conversations from './pages/conversations';
import Agents from './pages/agents';
import Myaccount from './pages/myaccount';
import Partners from './pages/partners';
import { useSelector } from 'react-redux';


const drawerWidth = "18%";

const Adminnav = () => {
    const navigate = useNavigate()
    const location = useLocation();
    const tuser = getsessionuser()
    const [refresh, setrefresh] = useState(false);
    const [user, setuser] = useState(tuser);
    const pathname = location?.pathname

    const webSettings = useSelector((state) => state.webSettings.data);

    const fullName = webSettings?.FULL_NAME;
    const firstname = fullName?.split(' ')[0];

    if (!tuser) {
        navigate('/')
    }


    const [messagecounter, setmessagecounter] = useState(0);

    const iconsize = 20
    const outlinefontsize = 13
    const [loading, setloading] = useState(false);
    const [logoutdialog, setlogoutdialog] = useState(false);

    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [showbackonline, setshowbackonline] = useState(false);

    useEffect(() => {
        const handleOnline = () => {
            setIsOnline(true);
            setshowbackonline(true)
            setTimeout(() => { setshowbackonline(false) }, 3000);
        };
        const handleOffline = () => {
            setIsOnline(false);
        };
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);


    useEffect(() => {
        const interval = setInterval(() => {
            getmessagecounter()
        }, 10000);
        // Clean up the interval on component unmount
        return () => {
            clearInterval(interval);
        };
    }, []);


    useEffect(() => {
        getmessagecounter()
        const userobject = sessionStorage?.getItem("user");
        if (userobject) {
            const object = JSON.parse(userobject)
            if (object?.username !== user?.username) {
                setuser(object)
            }
        }
    }, [refresh]);



    //logout from site
    const onlogout = () => {
        setlogoutdialog(false)
        setloading(true)
        setTimeout(() => {
            setloading(false)
            logoutuser()
            navigate("/../", { replace: true })
        }, 3000);
    }

    const getmessagecounter = () => {
        axios.get(Fetchmessagecounterurl).then(response => {
            if (!response.data.error) {
                // console.log(response.data)
                setmessagecounter(response.data.counter)
            } else {
                console.log(response.data.message)
            }
            // 
        }).catch(error => {
            console.log(error)
        });
    }


    const iconstyle = {
        color: "white"
    }
    const subiconstyle = {
        color: semiprimarycolor
    }
    const mainlinksstyle = {
        color: "white",
        fontSize: outlinefontsize
    }
    const mainlinksstyleactive = {
        color: semiprimarycolor,
        fontSize: outlinefontsize
    }

    return (
        <Box sx={{ display: 'flex' }}>
            {loading && <Loadingspinner />}
            {logoutdialog &&
                <Popupdialog
                    toptext={"Confirm exit!"}
                    question={"Are you sure you want to logout from this platform?"}
                    oncancel={() => setlogoutdialog(false)}
                    onsuccess={onlogout}
                    successtext={"Logout"} />
            }
            <CssBaseline />
            <AppBar 
                position="fixed"
                sx={{ width: `calc(100% - ${drawerWidth}px)`, ml: `${drawerWidth}px` }}
            >
                <Toolbar >
                    <div className='appbarstyle'>
                        <Typography color={"white"} variant="h6" noWrap component="div">
                            {firstname}® SUPPORT
                        </Typography>
                        <AccountMenu user={user} logout={() => setlogoutdialog(true)} counter={messagecounter} />
                    </div>
                </Toolbar> 
            </AppBar>
            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                        backgroundColor: primarycolor
                    },
                }}
                variant="permanent"
                anchor="left"
                color={primarycolor}
            >
                {!isOnline && <div className='offlinediv'>No internet Connection</div>}
                {showbackonline && <div className='onlinediv'>Back Online</div>}
                <Toolbar />
                <Divider />
                <List>
                    <ListItem disablePadding>
                        <ListItemButton onClick={() => navigate("dashboard")}>
                            <ListItemIcon>
                                <Speed size={iconsize} sx={pathname === "/supportdashboard/dashboard" ? subiconstyle : iconstyle} />
                            </ListItemIcon>
                            <ListItemText primary={"Dashboard"} primaryTypographyProps={pathname === "/supportdashboard/dashboard" ? mainlinksstyleactive : mainlinksstyle} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding onClick={() => navigate("conversations")}>
                        <ListItemButton>
                            <ListItemIcon>
                                <ForumOutlined size={iconsize} sx={pathname === "/supportdashboard/conversations" ? subiconstyle : iconstyle} />
                            </ListItemIcon>
                            <ListItemText primary={"Conversations"} primaryTypographyProps={pathname === "/supportdashboard/conversations" ? mainlinksstyleactive : mainlinksstyle} />
                        </ListItemButton>
                    </ListItem>
                    {/* {user.type !== 'Agent' &&
                        <ListItem disablePadding onClick={() => navigate("partners")}>
                            <ListItemButton>
                                <ListItemIcon>
                                    <HandshakeOutlined size={iconsize} sx={pathname === "/supportdashboard/partners" ? subiconstyle : iconstyle} />
                                </ListItemIcon>
                                <ListItemText primary={"Partner Requests"} primaryTypographyProps={pathname === "/supportdashboard/partners" ? mainlinksstyleactive : mainlinksstyle} />
                            </ListItemButton>
                        </ListItem>} */}
                    <ListItem disablePadding onClick={() => navigate("agents")}>
                        <ListItemButton>
                            <ListItemIcon>
                                <Group size={iconsize} sx={pathname === "/supportdashboard/agents" ? subiconstyle : iconstyle} />
                            </ListItemIcon>
                            <ListItemText primary={"Agents"} primaryTypographyProps={pathname === "/supportdashboard/agents" ? mainlinksstyleactive : mainlinksstyle} />
                        </ListItemButton>
                    </ListItem>
                    <ListItem disablePadding onClick={() => navigate("myaccount")}>
                        <ListItemButton>
                            <ListItemIcon>
                                <Person size={iconsize} sx={pathname === "/supportdashboard/myaccount" ? subiconstyle : iconstyle} />
                            </ListItemIcon>
                            <ListItemText primary={"Account"} primaryTypographyProps={pathname === "/supportdashboard/myaccount" ? mainlinksstyleactive : mainlinksstyle} />
                        </ListItemButton>
                    </ListItem>
                </List>
                <List>
                    <ListItem disablePadding onClick={() => setlogoutdialog(true)}>
                        <ListItemButton>
                            <ListItemIcon>
                                <PowerSettingsNewIcon size={iconsize} sx={iconstyle} />
                            </ListItemIcon>
                            <ListItemText primary={"Signout"} primaryTypographyProps={mainlinksstyle} />
                        </ListItemButton>
                    </ListItem>
                </List>
            </Drawer>
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    bgcolor: 'background.default',
                    p: 3,
                    maxWidth: '82%', // Set the maximum width to 100% of the viewport width
                }}
            >
                <Toolbar />
                <Routes>
                    <Route path="/*" exact element={<Navigate replace to="/supportdashboard/dashboard" />} />
                    <Route path="/dashboard" element={<Dashboard onlinestatus={isOnline} />} exact />
                    <Route path="/conversations" element={<Conversations messagecounter={messagecounter} onlinestatus={isOnline} />} exact />
                    <Route path="/agents" element={<Agents onlinestatus={isOnline} />} exact />
                    <Route path="/partners" element={<Partners onlinestatus={isOnline} />} exact />
                    <Route path="/myaccount" element={<Myaccount onlinestatus={isOnline} />} exact />
                </Routes>
            </Box>
        </Box>
    );
}



export default Adminnav;
